<template>
    <div class="box">
        <div class="title_box">
            <img v-if="$route.query.page_name=='b'" :src="img2" class="img" alt="">
            <img v-else :src="img1" class="img" alt="">
            <div class="text1">旺信通已为您发放</div>
            <div v-if="$route.query.page_name=='b'" class="text2">400条短信</div>
            <div v-else class="text2">100分钟通话</div>
        </div>
        <div class="text3">
            <img :src="require('@/assets/WelfareFebruary2.png')" >
            <div v-if="$route.query.page_name=='b'">
                检测到您商品未显示<span>响应快</span>标签会降低买家<span>52.36%</span>选择机会！
            </div>
            <div v-else>
                您有<span>63%</span>新客询单体验较差,平台已判定为<span>低响应店铺,</span>将减少新客询单转化！
            </div>
        </div>
        <div class="text4">
            <div v-if="$route.query.page_name=='b'">提高旺旺响应率至<span>80%以上</span><br />获得更多平台搜索流量</div>
            <div v-else>旺信通提高新客询单体验<br />至少可提升<span>46.5%</span>新客询单转化</div>
        </div>
        <div class="button_box">
            <div @click="show_popup" class="button">
                立即提升{{$route.query.page_name=='b'?'响应率':''}}
            </div>
        </div>
        <Popup v-model="popup_show"
        position="top"
        overlay-class="popup_box"
        :close-on-click-overlay="false"
        :lock-scroll="true"
        :lazy-render="false">
            <img class="WXTExtension_popup" :src="popup_img">
        </Popup>
    </div>
</template>
<script>
import { Popup } from 'vant';
export default {
    components:{
        Popup,
    },
    data(){
        
        let popup_img
        if(this.$config.SystemOS=='IOS'){
            popup_img = this.$OSSBaseUrl +'renew_tips_ios.png';
        }else{
            popup_img = this.$OSSBaseUrl + 'renew_tips_android.png';
        }
        let img1 = require('@/assets/WelfareFebruary1.png');
        let img2 = require('@/assets/WelfareFebruary4.png');
        return{
            popup_img,
            img1,
            img2,
            popup_show:false,
            record_data:{
                page_from:'main_page',
                page_name:'WelfareFebruary'+(this.$route.query.page_name?`?page_name=${this.$route.query.page_name}`:""),
                page_time:'0.00',
                receiver_id: '',
                page_param:{dayhour:this.$route.query.dayhour,},
            },
        }
    },
    mounted(){
        this.$store.dispatch('Public/inH5Record', this.record_data)
    },
    methods:{
        show_popup(){
            let data = JSON.parse(JSON.stringify(this.record_data))
            data.btn_name = 'WelfareFebruary'+(this.$route.query.page_name?`?page_name=${this.$route.query.page_name}`:"")
            this.$store.dispatch('Public/inH5Record', data)
            this.popup_show = true
        }
    },
}
</script>
<style lang="scss" scoped>
    @import './index.scss';
</style>